import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'
import { Color } from '../icon'

export interface ProgressSegment {
  value: number // The count or value for this segment
  color: Color // Color of the segment
  label?: string // Optional label
}

@Component({
  selector: 'hyperkit-segmented-progress-bar',
  templateUrl: './segmented-progress-bar.component.html',
  styleUrls: ['./segmented-progress-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedProgressBarComponent {
  @Input() segments: ProgressSegment[] = []
  @Input() showLabels = false // Whether to show labels below the bar
  @Input() showPercentages = false // Whether to show percentages instead of counts

  get totalValue(): number {
    return this.segments.reduce((sum, segment) => sum + segment.value, 0)
  }

  getSegmentPercentage(segment: ProgressSegment): number {
    if (this.totalValue === 0) return 0
    return (segment.value / this.totalValue) * 100
  }

  getSegmentWidth(segment: ProgressSegment): number {
    return this.getSegmentPercentage(segment)
  }
}
